import React, { PureComponent } from 'react'
import styles from './TaskRow.scss'
import {ClanTask} from "~/Actions/ActionClanTasks";
import ProgressBar from "@wg/wows-react-uikit/ProgressBar";
import {TASK_DESCRIPTIONS, TaskDescription} from "../constants";
import DivTooltip from "@wg/wows-react-uikit/DivTooltip";
import TooltipBody from "@wg/wows-react-uikit/TooltipBody";
import { t } from 'helpers/localization';
import TooltipHeader from '@wg/wows-react-uikit/TooltipHeader';
import Tooltip from '@wg/wows-react-uikit/Tooltip';
import {localizedDateTime} from "helpers/internalization";
import classNames from "classnames";
import settings from "settings";
import Button from '@wg/wows-react-uikit/Button';
import Spinner from "@wg/wows-react-uikit/Spinner";

export interface TaskRow_Props {
  isClaiming: boolean,
  task: ClanTask,
  canClaimRewards: boolean,
  onClaim: () => void
}

class TaskRow extends PureComponent<TaskRow_Props, any> {

    constructor(props) {
        super(props)

        this.state = {
          animated: false,
        }
    }

    public animate() {
      this.setState({...this.state, animated: true})
    }

    render() {
        const task = this.props.task

        const taskDescription = TASK_DESCRIPTIONS[task.name] as TaskDescription
        const descriptionTooltip = taskDescription.description ? (
          <Tooltip>
            <TooltipHeader><strong>{t('Выполнение задачи')}</strong></TooltipHeader>
            <TooltipBody>{taskDescription.description}</TooltipBody>
          </Tooltip>
        ) : (
          <TooltipBody><strong>{taskDescription.title}</strong></TooltipBody>
        )
        const withoutProgress = task.isClaimed || taskDescription.binary

        const progress = Math.floor(task.progress * taskDescription.total)
        let taskMessage = t('Задача не выполнена')

        let rewardTooltip = t('Становится доступной после выполения задачи')

        if (task.isFinished) {
          const finishedTill = new Date(task.finishedTill)
          taskMessage = <span className={styles.active}><span className={styles.checkIcon} />&nbsp;&nbsp;{t('Задача выполнена до')} {localizedDateTime(finishedTill)}</span>
          rewardTooltip = this.props.canClaimRewards ? t('Вы можете забрать награду') : t('Офицеры вашего клана могут забрать награду')
        }
        if (task.isClaimed) {
          const claimedAt = new Date(task.claimedAt)
          rewardTooltip = <span className={styles.active}><span className={styles.checkIcon} />&nbsp;&nbsp;{t('Награда получена')} {localizedDateTime(claimedAt)}</span>
        }

        return (
            <div className={classNames(styles.wrapper, {[styles.animated]: this.state.animated})}>
              <div className={styles.background} />
              <div className={styles.focus} />
              <div className={styles.content}>
                <DivTooltip>
                <div className={styles.iconWrapper}>
                  <div className={
                    classNames(
                      styles.taskIcon,
                      {[styles.finishedTaskIcon]: task.isFinished, [styles.claimedTaskIcon]: task.isClaimed}
                      )} />
                  </div>
                </DivTooltip>
                <div className={classNames(styles.descriptionWrapper, {[styles.descriptionWrapperBig]: withoutProgress})}>
                  <div className={styles.titleWrapper}>
                    <DivTooltip tooltipBody={descriptionTooltip}>
                        <span className={classNames(styles.title, {[styles.active]: task.isFinished})}>{taskDescription.title}</span>
                        <span className={styles.infoIcon} />
                    </DivTooltip>
                  </div>
                  { !withoutProgress ? (
                    <div className={styles.progress}>
                      <DivTooltip tooltipBody={
                        <Tooltip>
                          <TooltipHeader><strong>{t('Прогресс достижения')}</strong></TooltipHeader>
                          <TooltipBody>{t('Информация о прогрессе достижений обновляется  ежедневно в {update_time} по серверному времени').replace('{update_time}', settings.darwin.syncTime)}</TooltipBody>
                        </Tooltip>
                      }>
                          <ProgressBar
                            completed={progress / taskDescription.total}
                            size="small"
                            color="#ffcc66"
                          />
                          <span className={styles.progressCaption}>{progress}<span>/{taskDescription.total}</span></span>
                      </DivTooltip>
                    </div>
                  ) : null }
                </div>
                <div className={styles.rewardWrapper}>
                  <DivTooltip tooltipBody={
                        <Tooltip>
                          <TooltipHeader><strong>{t('Награда за выполнение')}</strong></TooltipHeader>
                          <TooltipBody>{rewardTooltip}</TooltipBody>
                        </Tooltip>
                      }>
                    <div className={styles.rewardResourceWrapper}>
                      { task.isClaimed ? <span className={classNames(styles.checkIcon, styles.rewardHasBeenClaimed)} /> : null }
                      { task.reward.coal ? <span className={classNames(styles.coal, {[styles.finished]: task.isFinished})}>{task.reward.coal}</span> : null }
                      { task.reward.oil ? <span className={classNames(styles.oil, {[styles.finished]: task.isFinished})}>{task.reward.oil}</span> : null }
                    </div>
                    { task.isFinished && !task.isClaimed && this.props.canClaimRewards ? (
                      <div className={styles.rewardButtonWrapper}>
                        { this.props.isClaiming ? <Spinner label="" /> : <Button onClick={this.props.onClaim}>{t('Забрать')}</Button> }
                      </div>
                    ) : null }
                  </DivTooltip>
                </div>
              </div>
            </div>
        )
    }
}

TaskRow.defaultProps = {
  isClaiming: false,
  canClaimRewards: false,
  onClaim: () => {},
}

export default TaskRow
